import React, {useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { RiLogoutBoxLine } from "react-icons/ri";
import Loader from '../Loader/Loader';
import { message } from 'antd';

function Navbar({toggleSidenav}) {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false)

  const opneLogoutModal = () => {
    setShowLogoutModal(true)
  }

  const handleLogout = async () => {
    setLoading(true);
    try {
      localStorage.clear();
      message.success("Successfully logged out")
      setShowLogoutModal(false)
      setTimeout(() => {
        window.location.href = '/login';

      }, [500])

    } catch (error) {
      console.log("error in log out", error)
      message.error("something went wrong")
    } finally {
      setLoading(false)
    }
  }


  return (
    <nav className="bg-gradient-to-br from-purple-700 to-purple-300 text-white p-4 flex justify-between items-center">
    <div className="flex items-center gap-6">
      <button
        className="w-10 h-10 rounded bg-white text-black"
        onClick={toggleSidenav}
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      <h1 className="text-xl font-bold">Giftr Admin</h1>

    </div>

    <div className='flex justify-end p-2 items-center rounded-md transition-colors cursor-pointer bg-gradient-to-br from-purple-700 to-purple-300 text-white hover:shadow-lg' 
    onClick={opneLogoutModal}
    >
    <RiLogoutBoxLine className="text-2xl mr-3"/>
      <h1 className="text-xl font-bold">Logout</h1>
      </div>


   
      {showLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm logout</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to logout ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowLogoutModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={handleLogout} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Logout
              </button>
            </div>
          </div>
        </div>
      )
      }
  
  {loading && <Loader/>}
  </nav>
  )
}

export default Navbar





